import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type GetKeywordListsQueryVariables = {};


export type GetKeywordListsQuery = (
  { __typename?: 'Query' }
  & { globalSettings: Array<(
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, 'options' | '_id' | 'type'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id' | 'type'>
    & { typeSettings: Array<(
      { __typename?: 'ProvingTypeSetting' }
      & Pick<Types.ProvingTypeSetting, 'type' | 'isActive'>
    )> }
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, 'value' | '_id' | 'type'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id' | 'type'>
  )> }
);

export type GetSettingByTypeQueryVariables = {
  settingType: Types.GlobalSettingType
};


export type GetSettingByTypeQuery = (
  { __typename?: 'Query' }
  & { globalSettingByType: Types.Maybe<(
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, 'options' | '_id' | 'type'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, 'value' | '_id' | 'type'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, '_id' | 'type'>
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id' | 'type'>
  )> }
);

export type CreateOrUpdateOptionMutationVariables = {
  type: Types.GlobalSettingType,
  options?: Types.Maybe<Array<Types.Scalars['String']>>
};


export type CreateOrUpdateOptionMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateSetting: (
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, '_id'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id'>
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, '_id'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, '_id'>
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id'>
  ) }
);

export type CreateOrUpdateSingleValueMutationVariables = {
  type: Types.GlobalSettingType,
  value: Types.Scalars['String']
};


export type CreateOrUpdateSingleValueMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateSetting: (
    { __typename?: 'OptionsSetting' }
    & Pick<Types.OptionsSetting, '_id'>
  ) | (
    { __typename?: 'ActiveProvingTypesSetting' }
    & Pick<Types.ActiveProvingTypesSetting, '_id'>
  ) | (
    { __typename?: 'SingleValueSetting' }
    & Pick<Types.SingleValueSetting, '_id'>
  ) | (
    { __typename?: 'FileSetting' }
    & Pick<Types.FileSetting, '_id'>
  ) | (
    { __typename?: 'GlobalMessageSetting' }
    & Pick<Types.GlobalMessageSetting, '_id'>
  ) }
);

export const GetKeywordListsDocument = gql`
    query getKeywordLists {
  globalSettings {
    _id
    type
    ... on OptionsSetting {
      options
    }
    ... on ActiveProvingTypesSetting {
      typeSettings {
        type
        isActive
      }
    }
    ... on SingleValueSetting {
      value
    }
  }
}
    `;

    export function useGetKeywordListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetKeywordListsQuery, GetKeywordListsQueryVariables>) {
      return ApolloReactHooks.useQuery<GetKeywordListsQuery, GetKeywordListsQueryVariables>(GetKeywordListsDocument, baseOptions);
    };
      export function useGetKeywordListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetKeywordListsQuery, GetKeywordListsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<GetKeywordListsQuery, GetKeywordListsQueryVariables>(GetKeywordListsDocument, baseOptions);
      };
      
export type GetKeywordListsQueryHookResult = ReturnType<typeof useGetKeywordListsQuery>;
export type GetKeywordListsQueryResult = ApolloReactCommon.QueryResult<GetKeywordListsQuery, GetKeywordListsQueryVariables>;
export const GetSettingByTypeDocument = gql`
    query getSettingByType($settingType: GlobalSettingType!) {
  globalSettingByType(type: $settingType) {
    _id
    type
    ... on OptionsSetting {
      options
    }
    ... on SingleValueSetting {
      value
    }
  }
}
    `;

    export function useGetSettingByTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSettingByTypeQuery, GetSettingByTypeQueryVariables>) {
      return ApolloReactHooks.useQuery<GetSettingByTypeQuery, GetSettingByTypeQueryVariables>(GetSettingByTypeDocument, baseOptions);
    };
      export function useGetSettingByTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSettingByTypeQuery, GetSettingByTypeQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<GetSettingByTypeQuery, GetSettingByTypeQueryVariables>(GetSettingByTypeDocument, baseOptions);
      };
      
export type GetSettingByTypeQueryHookResult = ReturnType<typeof useGetSettingByTypeQuery>;
export type GetSettingByTypeQueryResult = ApolloReactCommon.QueryResult<GetSettingByTypeQuery, GetSettingByTypeQueryVariables>;
export const CreateOrUpdateOptionDocument = gql`
    mutation createOrUpdateOption($type: GlobalSettingType!, $options: [String!]) {
  createOrUpdateSetting(input: {type: $type, options: $options}) {
    _id
  }
}
    `;
export type CreateOrUpdateOptionMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateOptionMutation, CreateOrUpdateOptionMutationVariables>;

    export function useCreateOrUpdateOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateOptionMutation, CreateOrUpdateOptionMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateOrUpdateOptionMutation, CreateOrUpdateOptionMutationVariables>(CreateOrUpdateOptionDocument, baseOptions);
    };
export type CreateOrUpdateOptionMutationHookResult = ReturnType<typeof useCreateOrUpdateOptionMutation>;
export type CreateOrUpdateOptionMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateOptionMutation>;
export type CreateOrUpdateOptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateOptionMutation, CreateOrUpdateOptionMutationVariables>;
export const CreateOrUpdateSingleValueDocument = gql`
    mutation createOrUpdateSingleValue($type: GlobalSettingType!, $value: String!) {
  createOrUpdateSetting(input: {type: $type, value: $value}) {
    _id
  }
}
    `;
export type CreateOrUpdateSingleValueMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateSingleValueMutation, CreateOrUpdateSingleValueMutationVariables>;

    export function useCreateOrUpdateSingleValueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateSingleValueMutation, CreateOrUpdateSingleValueMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateOrUpdateSingleValueMutation, CreateOrUpdateSingleValueMutationVariables>(CreateOrUpdateSingleValueDocument, baseOptions);
    };
export type CreateOrUpdateSingleValueMutationHookResult = ReturnType<typeof useCreateOrUpdateSingleValueMutation>;
export type CreateOrUpdateSingleValueMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateSingleValueMutation>;
export type CreateOrUpdateSingleValueMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateSingleValueMutation, CreateOrUpdateSingleValueMutationVariables>;